
import omit from 'lodash/omit';
import reject from 'lodash/reject';

import { CATEGORY_SELECTION_ACTIONS } from 'app/constants';
import { CategoryServiceModule } from 'services/data/categories.service';
import { ModelModule } from 'services/data/model/model.module';
import { SeoHelperServiceModule } from 'services/utilities/seoHelper.service';

import template from './categoryPicker.html';
import './categoryPicker.scss';

export const CategoryPickerModule = angular
    .module('app.components.categoryPicker', [
        'ngMaterial',
        CategoryServiceModule,
        ModelModule,
        SeoHelperServiceModule
    ])
    .component('categoryPicker', {
        template,
        bindings: {
            title: '@',
            placeholder: '@',
            createNewCategoryText: '@',
            noResultsText: '@',
            singleSelection: '<',
            categoryIds: '<',
            excludedCategoryIds: '<',
            onSelectedCategoriesChanged: '&',
            key: '@'
        },
        controller: class CategoryPickerController {
            constructor(categoryService, modelService, seoHelperService) {
                'ngInject';

                angular.extend(this, {
                    categoryService,
                    modelService,
                    seoHelperService,
                    categoryTree: [],
                    selectedCategories: [],
                    categoryLineages: [],
                    autocomplete: {
                        selectedItem: null,
                        searchText: '',
                        disabled: false
                    }
                });
            }

            $onInit() {
                this.autocomplete.placeholder = this.placeholder;
                this.key = this.key || 'categoryId';
                if (!angular.isArray(this.categoryIds)) {
                    this.categoryIds = [];
                }

                this.categoryService.getCategoryTree().then((categoryTree) => {
                    this.categoryTree = categoryTree;

                    this.categoryLineages = this.initialize(categoryTree);
                    if (this.categoryIds.length > 0) {
                        this.setSelectedAndCategoryLineages();
                    }
                });
            }

            $onChanges(changes) {
                if (changes.categoryIds) {
                    this.categoryLineages = this.initialize(this.categoryTree);
                    this.setSelectedAndCategoryLineages();
                }
            }

            initialize(categoryTree) {
                const identifierKey = this.key;
                const categoryLineages = [];
                const excludedCategoryIds = this.excludedCategoryIds || [];

                function getLineage(parentLineage, categoryName) {
                    return parentLineage
                        ? `${parentLineage} > ${categoryName}`
                        : categoryName;
                }

                function setLineageOnCategoryTree(categories, parentLineage = '') {
                    categories.forEach((category) => {
                        const lineage = getLineage(parentLineage, category.name);
                        if (excludedCategoryIds.indexOf(category[identifierKey]) < 0) {
                            categoryLineages.push({ id: category[identifierKey], lineage, state: category.state });
                            if (angular.isArray(category.subCategories) && category.subCategories.length > 0) {
                                setLineageOnCategoryTree(category.subCategories, lineage);
                            }
                        }
                    });
                }

                setLineageOnCategoryTree(categoryTree);
                return categoryLineages;
            }

            setSelectedAndCategoryLineages() {
                if (!this.categoryLineages) {
                    return;
                }
                this.selectedCategories =
                    this.categoryLineages.filter(category => this.categoryIds.includes(category.id));
                this.categoryLineages = reject(this.categoryLineages, (category) => {
                    return this.categoryIds.includes(category.id);
                });
                this.checkSingleSelection();
            }

            checkSingleSelection() {
                if (this.singleSelection && this.categoryIds.length === 1) {
                    this.autocomplete.disabled = true;
                    this.autocomplete.placeholder = '';
                } else {
                    this.autocomplete.disabled = false;
                    this.autocomplete.placeholder = this.placeholder;
                }
            }

            querySearch(searchText) {
                searchText = searchText.toLowerCase();
                return this.categoryLineages.filter((categoryLineage) => {
                    return categoryLineage.lineage.toLowerCase().indexOf(searchText) !== -1;
                });
            }

            addCategory(selectedItem) {
                if (!selectedItem || (this.singleSelection && this.categoryIds.length === 1)) {
                    return;
                }
                this.selectedCategories.push(selectedItem);
                this.categoryIds.push(selectedItem.id);
                this.categoryLineages = reject(this.categoryLineages, { id: selectedItem.id });
                this.checkSingleSelection();
                if (angular.isFunction(this.onSelectedCategoriesChanged)) {
                    this.onSelectedCategoriesChanged({
                        selectedCategories: this.categoryIds,
                        action: CATEGORY_SELECTION_ACTIONS.ADD
                    });
                }
            }

            removeCategory(itemToRemove) {
                this.selectedCategories = reject(this.selectedCategories, { id: itemToRemove.id });
                this.categoryIds = this.categoryIds.filter(c => c !== itemToRemove.id);
                this.categoryLineages.push(itemToRemove);
                this.checkSingleSelection();
                if (angular.isFunction(this.onSelectedCategoriesChanged)) {
                    this.onSelectedCategoriesChanged({
                        selectedCategories: this.categoryIds,
                        action: CATEGORY_SELECTION_ACTIONS.REMOVE
                    });
                }
            }

            createCategory(categoryName) {
                const parentCategory = this.modelService.makeModel({
                    name: categoryName,
                    state: 'Active'
                },
                'categoryModel');
                this.seoHelperService.fillDefaultValues(parentCategory, parentCategory.state);
                this.categoryService.createNewCategory(omit(parentCategory,
                    'categoryId',
                    'contentPageId',
                    'images',
                    'subCategories',
                    'productCount'
                ))
                    .then((response) => {
                        const parentCategoryLineage = {
                            id: response[this.key],
                            lineage: response.name,
                            state: response.state
                        };
                        this.categoryLineages.push(parentCategoryLineage);
                        this.addCategory(parentCategoryLineage);
                        this.autocomplete.searchText = '';
                    });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/categoryPicker/categoryPicker.component.js